/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */

import React /* , { useCallback } */ from 'react';
// import { useDispatch } from 'react-redux';
import Model from '@tripian/model';
import { PoiRefCard, PreLoading, CloseIconButton } from '@tripian/react';

import './FavoritesContainer.scss';
import config from '../../../../../config';
import IFavoritePoi from '../../../../../models/IFavoritePoi';
// import { changeFavoritesVisible } from '../../../../../redux/action/layout';

import useFavorite from '../../../../../hooks/useFavorite';
import useFocus from '../../../../../hooks/useFocus';

interface IFavoritesContainer {
  show: boolean;
  close: () => void;
  dayIndex: number;
}

const FavoritesContainer: React.FC<IFavoritesContainer> = ({ show, close /* , dayIndex */ }) => {
  const { favorites, loadingFavorites, loadingFavoritePoi, favoriteDelete } = useFavorite();
  const { focusPoi } = useFocus();

  const favoritesContainerClasses = ['favoritesContainer'];
  if (config.HIDE_OVERVIEW) favoritesContainerClasses.push('container-height');
  else favoritesContainerClasses.push('container-height-tab');
  if (show) favoritesContainerClasses.push('favoritesContainerOpen');
  else favoritesContainerClasses.push('favoritesContainerClose');

  const renderContent = () => {
    if (loadingFavorites && favorites === undefined) return <PreLoading />;

    if (favorites) {
      if (favorites.length === 0)
        return (
          <div className="center">
            <span>No favorites yet.</span>{' '}
          </div>
        );

      return favorites.map((favoritePoi: IFavoritePoi) =>
        loadingFavoritePoi(favoritePoi.poi_id) ? (
          <div className="favorite-items-loading">
            <PreLoading key={`favorite-poi-ref-card-${favoritePoi.id}`} />
          </div>
        ) : (
          <PoiRefCard
            key={`favorite-poi-ref-card-${favoritePoi.id}`}
            poi={favoritePoi.poi}
            buttonType={-1}
            poiCardClicked={(p) => {
              // eslint-disable-next-line no-console
              console.log(p);
              focusPoi(p);
            }}
            addRemoveAlternativePoi={(poi: Model.Poi) => {
              const currentFavoriteId = (favorites || []).find((f) => f.poi_id === poi.id)?.id;
              if (currentFavoriteId) {
                // dispatch(favoriteDeleteAndFetch(currentFavoriteId, poi.id, cityId));
                favoriteDelete(currentFavoriteId, poi.id);
                // eslint-disable-next-line no-console
              } else console.error('FavoriteContainer: favoriteDeleteAndFetch called with unknown favorite id');
            }}
          />
        ),
      );
    }

    return null;
  };

  return (
    <div className={favoritesContainerClasses.join(' ')}>
      <div className="scrollable-y" style={{ height: '100%' }}>
        <div className="favorites-close-icon m3">
          <CloseIconButton fill="#000" clicked={close} />
        </div>
        <h3 className="center mt12">Favorites</h3>
        <div className="px4 mt5">{renderContent()}</div>
      </div>
    </div>
  );
};

export default FavoritesContainer;
